module.exports = __webpack_public_path__ + "static/media/X.207b11e7.png";